import { StreamActions } from "@hotwired/turbo"

StreamActions.toast = function() {
    $.notify(
        {
            icon: "add_alert",
            message: this.getAttribute("message")
        },
        {
            type: this.getAttribute("style"),
            timer: 100,
            placement: {
                from: "top",
                align: "right"
            }
        });
}

